import { PipesModule } from '../../pipes/pipes.module';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BhHeaderLargeComponent } from './bh-header-large.component';

@NgModule({
  declarations: [
    BhHeaderLargeComponent
    ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    PipesModule
  ],
  exports: [
    BhHeaderLargeComponent
  ]
})
export class BhHeaderLargeComponentModule { }
